import api from 'services/inventory/maintenance-schedule'
import { AutocompleteResult } from 'utils/types'

export const maintenanceScheduleAutocomplete = async (text: string): Promise<Array<AutocompleteResult>> => {
  if (!text) return []

  let res = await api.autocomplete({ text })

  if (!res?.data?.success) return []

  return res?.data?.data
}
